// Just enough user-agent parsing to name the WebView engine and version.

export function parseUserAgent(ua = '') {
    const out = { engine: null, engineVersion: null, os: null, osVersion: null }
    let m
    if ((m = ua.match(/Chrome\/([\d.]+)/))) {
        out.engine = /; wv\)/.test(ua) ? 'Android System WebView' : 'Chrome'
        out.engineVersion = m[1]
    } else if ((m = ua.match(/AppleWebKit\/([\d.]+)/))) {
        out.engine = 'WebKit'
        out.engineVersion = (ua.match(/Version\/([\d.]+)/) || [])[1] ?? m[1]
    } else if ((m = ua.match(/Firefox\/([\d.]+)/))) {
        out.engine = 'Gecko'
        out.engineVersion = m[1]
    }
    if ((m = ua.match(/Android ([\d.]+)/))) { out.os = 'Android'; out.osVersion = m[1] }
    else if ((m = ua.match(/(?:iPhone )?OS (\d+[_\d]*) like Mac OS X/))) { out.os = 'iOS'; out.osVersion = m[1].replace(/_/g, '.') }
    else if ((m = ua.match(/Mac OS X ([\d_]+)/))) { out.os = 'macOS'; out.osVersion = m[1].replace(/_/g, '.') }
    return out
}
